<template>
  <Head :title="`Profilul meu`" />
  <div class="flex h-full w-full justify-center">
    <div class="h-full relative w-full lg:w-5/7">
      <div
        class="overflow-y-auto h-full w-full absolute bg-gray-100 py-12 xs:px-12 rounded-lg"
      >
        <Tabs value="0">
          <TabList
            pt:active-bar:class="bg-primary-color"
            pt:tablist:class="w-max xs:w-full"
          >
            <Tab value="0">Status Programe</Tab>
            <Tab value="1">Date profil</Tab>
            <Tab value="2">Securitate</Tab>
          </TabList>
          <TabPanels>
            <TabPanel pt:root:tabindex="-1" value="1">
              <div class="flex flex-col">
                <text-input
                  v-model="userObj.first_name"
                  class="w-full pb-4 md:w-1/2"
                  label="Prenume"
                  disabled
                />
                <text-input
                  v-model="userObj.last_name"
                  class="w-full pb-4 md:w-1/2"
                  label="Nume"
                  disabled
                />
                <text-input
                  v-model="userObj.email"
                  class="w-full pb-4 md:w-1/2"
                  label="Email"
                  disabled
                />
                <text-input
                  v-model="userObj.telephone"
                  class="w-full pb-4 md:w-1/2"
                  label="Telefon"
                  disabled
                />
                <text-input
                  v-model="userObj.company"
                  class="w-full pb-4 md:w-1/2"
                  label="Companie"
                  disabled
                />
              </div>
            </TabPanel>
            <TabPanel pt:root:tabindex="-1" value="0">
              <div class="flex flex-col gap-6">
                <div v-if="trainingCourses.length">
                  <h3 class="text-xl font-semibold mb-2">Cursuri</h3>
                  <div class="flex flex-col gap-2">
                    <div
                      v-for="(uc, index) in trainingCourses"
                      :key="uc.id"
                      class="bg-white rounded-sm p-3 shadow-sm flex flex-row gap-2"
                    >
                      <span class="font-bold">{{ index + 1 }}.</span>
                      <div class="grid grid-cols-1 md:grid-cols-2 w-full">
                        <div class="text-md">
                          {{ uc.course?.name }}
                        </div>
                        <div class="text-md mt-1 md:mt-0">
                          <span class="font-bold">Status:</span>
                          {{ formatStatus(uc.status) }}
                          <span
                            v-if="uc.status === 'Finalized'"
                            class="ml-1 text-green-600 font-bold"
                            title="Curs finalizat"
                          >
                            ✓
                          </span>
                        </div>
                        <div class="text-sm text-gray-600 md:col-span-2 mt-2">
                          <span class="font-bold">{{
                            uc.rescheduled
                              ? 'Date planificare initiala:'
                              : 'Perioada derulare:'
                          }}</span>

                          {{ formatDate(uc.start_date) || '-' }} -
                          {{ formatDate(uc.end_date) || '-' }}
                        </div>
                        <div
                          v-if="uc.rescheduled"
                          class="text-sm text-primary-color md:col-span-2 mt-1"
                        >
                          Date replanificare:
                          <span v-if="uc.restart_start_date">
                            {{ formatDate(uc.restart_start_date) }} -
                          </span>
                          <span v-if="uc.restart_end_date">
                            {{ formatDate(uc.restart_end_date) }}
                          </span>
                        </div>
                        <div
                          v-if="uc.diploma_url"
                          class="text-sm md:col-span-2 mt-3"
                        >
                          <a
                            :href="uc.diploma_url"
                            class="inline-flex items-center px-3 py-1.5 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                          >
                            📄 Descarca Diploma
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="certificationCourses.length">
                  <h3 class="text-xl font-semibold mb-2">Certificari</h3>
                  <div class="flex flex-col gap-2">
                    <div
                      v-for="(uc, index) in certificationCourses"
                      :key="uc.id"
                      class="bg-white rounded-sm p-3 shadow-sm flex flex-row gap-2"
                    >
                      <span class="font-bold">{{ index + 1 }}.</span>
                      <div class="grid grid-cols-1 md:grid-cols-2 w-full">
                        <div class="text-md">
                          {{ uc.course?.name }}
                        </div>
                        <div class="text-md mt-1 md:mt-0">
                          <span class="font-bold">Status:</span>
                          {{ formatStatus(uc.status) }}
                          <span
                            v-if="uc.status === 'Finalized'"
                            class="ml-1 text-green-600 font-bold"
                            title="Curs finalizat"
                          >
                            ✓
                          </span>
                        </div>
                        <div class="text-sm text-gray-600 md:col-span-2 mt-2">
                          <span class="font-bold">{{
                            uc.rescheduled
                              ? 'Date planificare initiala:'
                              : 'Perioada derulare:'
                          }}</span>

                          {{ formatDate(uc.start_date) || '-' }} -
                          {{ formatDate(uc.end_date) || '-' }}
                        </div>
                        <div
                          v-if="uc.rescheduled"
                          class="text-sm text-primary-color md:col-span-2 mt-1"
                        >
                          Date replanificare:
                          <span v-if="uc.restart_start_date">
                            {{ formatDate(uc.restart_start_date) }} -
                          </span>
                          <span v-if="uc.restart_end_date">
                            {{ formatDate(uc.restart_end_date) }}
                          </span>
                        </div>
                        <div class="text-sm text-gray-600 mt-2 md:col-span-2">
                          <span class="underline">Data predare proiect</span>:
                          {{ formatDate(uc.project_date) || '-' }}
                        </div>
                        <div class="text-sm text-gray-600 mt-2 md:col-span-2">
                          <span class="underline font-medium"
                            >Testare cunostinte teoretice</span
                          >:
                        </div>
                        <template v-if="uc.exam_results?.length">
                          <div
                            v-for="(exam, i) in uc.exam_results"
                            :key="i"
                            class="text-sm ml-2 md:col-span-2 mb-1"
                          >
                            <span class="font-medium">{{
                              exam.subject_name
                            }}</span>
                            <span class="text-gray-500 ml-1">
                              {{ formatDate(exam.date) }}:
                              <span
                                :class="
                                  exam.passed
                                    ? 'text-green-600 font-semibold'
                                    : 'text-red-600 font-semibold'
                                "
                              >
                                {{
                                  quizResultPercentage(
                                    exam.correct_count,
                                    exam.total_questions,
                                  )
                                }}% ({{ exam.correct_count }}/{{
                                  exam.total_questions
                                }})
                              </span>
                              &mdash;
                              {{ exam.passed ? 'Promovat' : 'Nepromovat' }}
                            </span>
                          </div>
                        </template>
                        <div
                          v-else
                          class="text-sm text-gray-500 ml-2 md:col-span-2"
                        >
                          Nu au fost sustinute examene.
                        </div>
                        <div class="text-sm text-gray-600 mt-2 md:col-span-2">
                          <span class="underline">Data prezentare proiect</span
                          >:
                          <template v-if="uc.presentation_date">
                            <span>
                              {{
                                (formatDate(uc.presentation_date) || '-') + ' '
                              }}
                            </span>
                            <span v-if="uc.presentation_start_time">
                              {{ uc.presentation_start_time + '-' }}
                            </span>
                            <span v-if="uc.presentation_end_time">
                              {{ uc.presentation_end_time }}
                            </span>
                          </template>
                          <span v-else>
                            {{ '-' }}
                          </span>
                        </div>
                        <div
                          v-if="uc.diploma_url || uc.grades_paper_url"
                          class="text-sm md:col-span-2 mt-3 flex flex-wrap gap-2"
                        >
                          <a
                            v-if="uc.diploma_url"
                            :href="uc.diploma_url"
                            class="inline-flex items-center px-3 py-1.5 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                          >
                            📄 Descarca Diploma
                          </a>
                          <a
                            v-if="uc.grades_paper_url"
                            :href="uc.grades_paper_url"
                            class="inline-flex items-center px-3 py-1.5 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                          >
                            📄 Descarca Foaie matricola
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="!trainingCourses.length && !certificationCourses.length"
                  class="text-gray-600"
                >
                  Nu ai cursuri atribuite momentan.
                </div>
              </div>
            </TabPanel>
            <TabPanel pt:root:tabindex="-1" value="2">
              <form @submit.prevent="$emit('submit')" @submit="submit">
                <PasswordInput
                  v-model="form.user.current_password"
                  :error="form.errors.current_password"
                  label="Parola curenta"
                  class="w-full pb-2 md:w-1/2 mt-2"
                />
                <PasswordInput
                  v-model="form.user.password"
                  :error="form.errors.password"
                  class="w-full pb-2 md:w-1/2"
                  label="Parola noua"
                />
                <PasswordInput
                  v-model="form.user.password_confirmation"
                  :error="form.errors.password_confirmation"
                  class="w-full pb-2 md:w-1/2"
                  label="Repeta parola noua"
                />
                <div class="flex items-center py-4">
                  <loading-button
                    :loading="form.processing"
                    class="btn-no-color field-primary-colors"
                    type="submit"
                  >
                    Modifica parola
                  </loading-button>
                </div>
              </form>
              <transition-group
                name="p-message"
                tag="div"
                class="flex flex-col"
              >
                <Message
                  v-for="(msg, index) of messages"
                  :key="index"
                  severity="success"
                  :life="3000"
                  icon="pi pi-check"
                  closable
                >
                  {{ msg }}
                </Message>
              </transition-group>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3';
import Layout from '@/Layouts/Main.vue';
import LoadingButton from '@/Shared/LoadingButton.vue';
import TextInput from '@/Shared/TextInput.vue';
import PasswordInput from '@/Shared/PasswordInput.vue';
import axios from 'axios';

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import Message from 'primevue/message';
import {
  formatDate,
  formatReason,
  formatStatus,
  quizResultPercentage,
} from '@/utils/formatters';

export default {
  components: {
    Head,
    LoadingButton,
    TextInput,
    PasswordInput,

    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    Message,
  },
  layout: Layout,
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  emits: ['submit'],
  data() {
    return {
      userObj: this.user,
      form: this.$inertia.form({
        user: {
          password: '',
          password_confirmation: '',
          current_password: '',
        },
      }),
      passwordChangeSuccess: false,
      messages: [],
    };
  },
  computed: {
    trainingCourses() {
      const list = this.userObj.user_courses || [];
      return list.filter(
        (uc) => (uc.course?.type || '').toLowerCase() === 'training',
      );
    },
    certificationCourses() {
      const list = this.userObj.user_courses || [];
      return list.filter(
        (uc) => (uc.course?.type || '').toLowerCase() === 'certification',
      );
    },
  },
  methods: {
    quizResultPercentage,
    submit() {
      let self = this;
      axios
        .patch(this.$routes.update_password_user(this.userObj.id), {
          format: 'json',
          ...this.form,
        })
        .then(function () {
          self.messages.push('Parola a fost modificata cu success');
          self.form.errors = {};
          self.form.user = {
            password: '',
            password_confirmation: '',
            current_password: '',
          };
        })
        // TODO: handle the error
        .catch(function (error) {
          self.form.errors = error.response.data.errors;
        });
    },
    formatReason,
    formatStatus,
    formatDate,
  },
};
</script>

<style>
.p-tab-active {
  color: #c00020;
}
</style>
